// services import
import { AppNameProvider } from './app-name';
import { RedirectAnonymousToGateProvider } from './redirect-anonymous-to-gate';

export const services: any[] = [
  // services export
  AppNameProvider,
  RedirectAnonymousToGateProvider,
];
